import { getMessage } from '@tcc/i18n';
import { BASE_LAYERS } from '../constants/mapLayerIds';

export const filterSoilSurgoLayers = (
  baseLayerSubOptions,
  soilssurgoLayer = {}
) => {
  const { zones } = soilssurgoLayer;
  if (!zones) {
    return baseLayerSubOptions;
  }

  zones.some(
    (zone) =>
      zone.drainage &&
      baseLayerSubOptions.push({
        id: BASE_LAYERS.DRAINAGE,
        name: getMessage('layer.drainage'),
        disabled: false,
      })
  );

  zones.some(
    (zone) =>
      zone.soilType &&
      baseLayerSubOptions.push({
        id: BASE_LAYERS.SOIL_TYPE,
        name: getMessage('layer.soilType'),
        disabled: false,
      })
  );
  return baseLayerSubOptions;
};
